import React from 'react';
import { Routes, Route } from 'react-router-dom';
import DoctorDashboard from '../components/Doctor/DoctorDashboard';
import PatientSearch from '../components/Doctor/PatientSearch';
import EPrescriptionForm from '../components/Doctor/EPrescriptionForm';

const DoctorPage = () => {
  return (
    <div className="page-content">
      <Routes>
        <Route path="accueil" element={<DoctorDashboard />} />
        <Route path="search" element={<PatientSearch />} />
        <Route path="prescribe" element={<EPrescriptionForm />} />
      </Routes>
    </div>
  );
};

export default DoctorPage;